export default __webpack_public_path__ + "static/media/long.2e0e188a.svg";